export const fromLinkInputs = (state, name, onChange = () => {}) => {
  return {
    onChange: (value) => {
      const {
        isValid,
        message
      } = CheckValidation({
        validations: state.state.form[name].validations,
        value: value
      }, state)

      state.setState({
        form: {
          ...state.state.form,
          [name]: {
            ...state.state.form[name],
            value: value,
            isValid: isValid,
            dirty: true,
            message: message
          }
        }
      }, () => {
        const disabled = []
        const form = { ...state.state.form }
        Object.keys(form).forEach(inputName => {
          if (inputName !== "submitButton") {
            form[inputName] = CheckValidation(form[inputName], state)
            if (!form[inputName].isValid) {
              disabled.push(form[inputName])
            }
          }
        })
        state.setState({
          form: {
            ...state.state.form,
            submitButton: {
              ...state.state.form.submitButton,
              disabled: disabled.length > 0
            }
          }
        }, () => onChange(value))
      })
    },
    getThisInput: (inputThis) => {
      if (!state.form) state.form = []
      state.form[name] = inputThis
    },
    defaultValue: state.state.form[`${name}`].defaultValue,
    required: state.state.form[name].validations && state.state.form[name].validations.required,
    message: state.state.form[`${name}`].message,
    isValid: !state.state.form[`${name}`].dirty || state.state.form[`${name}`].isValid
  }
}

export const formLinkSubmit = (state, onSubmit = () => {}) => {
  return {
    onClick: () => {
      const disabled = []
      const form = { ...state.state.form }
      Object.keys(form).forEach(inputName => {
        if (inputName !== "submitButton") {
          form[inputName] = { ...CheckValidation(form[inputName], state) }
          form[inputName].dirty = true
          if (!form[inputName].isValid) {
            disabled.push(form[inputName])
          }
        }
      })

      state.setState({
        form: {
          ...form,
          submitButton: {
            ...form.submitButton,
            disabled: disabled.length > 0
          }
        }
      }, () => {
        if (!form.submitButton.disabled) onSubmit()
      })
    },
    disabled: state.state.form.submitButton.disabled
  }
}

export const formSetDefaultValues = async (state, values = {}, callback = () => {}) => {
  await Object.keys(values).forEach(async (inputName, item) => {
    if (state.form && state.form[inputName] && (values[inputName] || values[inputName] === false)) {
      await setTimeout(() => {
        state.form[inputName]._onChange(values[inputName], true)
      }, 10)
    }
  })
  callback()
}

export const formSetValidations = (state, name, newValidations = {}) => {
  const form = { ...state.state.form }
  Object.keys(form).forEach(inputName => {
    if (inputName !== "submitButton") {
      form[inputName].isValid = true
      if (inputName === name) {
        form[inputName].validations = newValidations
      }
    }
  })

  state.setState({
    form: form
  }, () => {
    const disabled = []
    const form = { ...state.state.form }
    Object.keys(form).forEach(inputName => {
      if (inputName !== "submitButton") {
        form[inputName] = CheckValidation(form[inputName], state)
        if (!form[inputName].isValid) {
          disabled.push(form[inputName])
        }
      }
    })
    state.setState({
      form: {
        ...state.state.form,
        submitButton: {
          ...state.state.form.submitButton,
          disabled: disabled.length > 0
        }
      }
    })
  })
}

const CheckValidation = (newInput, state) => {
  let isValid = true
  let message = ""
  if (newInput.validations) {
    // validations
    // --> required
    // --> phone


    if (isValid && newInput.validations.phone) {
      if (newInput.value) {
        if (newInput.value.length < 9) {
          isValid = false
        } else if (!String(newInput.value).match(/^0(2|3|4|7|8|9)\d+$/)) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.phone
      }
    }

    if (isValid && newInput.validations.mobilePhone) {
      if (newInput.value) {
        if (newInput.value.length < 9) {
          isValid = false
        } else if (!String(newInput.value).match(/^04\d+$/)) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.mobilePhone
      }
    }

    if (isValid && newInput.validations.extension) {
      if (newInput.value) {
        if (newInput.value.length > 6) {
          isValid = false
        } else if (!String(newInput.value).match(/\[?([0-9])\]?/g)) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.extension
      }
    }

    if (isValid && newInput.validations.email) {
      if (newInput.value) {
        if (newInput.value.length > 60) {
          isValid = false
        } else if (!String(newInput.value).match(/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/)) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.email
      }
    }

    if (isValid && newInput.validations.address) {
      if (newInput.value) {
        if (!newInput.value.streetNumber) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.address
      }
    }

    if (isValid && newInput.validations.postcode) {
      // if (newInput.value) {
      //   if (newInput.value.length < 4) {
      //     isValid = false
      //   } else if (!String(newInput.value).match(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/)) {
      //     isValid = false
      //   }
      //   message = isValid ? "" : newInput.validations.postcode
      // }
    }

    if (isValid && newInput.validations.odometer) {
      if (newInput.value) {
        if (!String(newInput.value).match(/^[0-9]*$/)) {
          isValid = false
        } else if (newInput.value.indexOf(".") > -1) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.odometer
      }
    }

    if (isValid && newInput.validations.postcodeSearchable) {
      if (newInput.value) {
        if (!newInput.value.postcode){
          isValid = false
        } else if (newInput.value.postcode.length < 4) {
          isValid = false
        } else if (!String(newInput.value.postcode).match(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/)) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.postcodeSearchable
      }
    }

    if (isValid && newInput.validations.businessName) {
      if (newInput.value) {
        if (newInput.value.length > 200) {
          isValid = false
        } else if (!String(newInput.value).match(/^[A-Za-z0-9!#$%&'()*,-.\/:;=?@\\_{|}]+(?: [A-Za-z0-9!#$%&'()*,-.\/:;=?@\\_{|}]+)*$/)) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.postcode
      }
    }

    if (isValid && newInput.validations.confirmPassword) {
      if (newInput.value) {
        if (newInput.value != state.state.form.password.value) {
          isValid = false
        }
        message = isValid ? "" : newInput.validations.confirmPassword
      }
    }

    if (isValid && newInput.validations.required) {
      isValid = !!(newInput.value && newInput.value !== "")
      message = isValid ? "" : newInput.validations.required
    }
  }

  const result = { ...newInput }
  result.isValid = isValid
  result.message = message

  return result
}



// WEBPACK FOOTER //
// ./src/AtomicUtils/formHandler.js